export { default } from "./useStudentSearchRestrictionsGet";
